<div class="table-footer-container">
  <app-table-results-text [totalCount]="totalCount" [pageSize]="pageSize" [skip]="skip" />
  <app-table-paginator
    [skip]="skip"
    [totalCount]="totalCount"
    [pageSize]="pageSize"
    (skipChanged)="skipChanged.emit($event)" />
</div>
